import { render, staticRenderFns } from "./relationshipMaintenance.vue?vue&type=template&id=12489b51&scoped=true"
import script from "./relationshipMaintenance.vue?vue&type=script&lang=js"
export * from "./relationshipMaintenance.vue?vue&type=script&lang=js"
import style0 from "./relationshipMaintenance.vue?vue&type=style&index=0&id=12489b51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12489b51",
  null
  
)

export default component.exports